exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nul.pagination {\n  list-style-type: none;\n}\nul.pagination .pagination-item {\n  display: inline-block;\n}\nul.pagination .active {\n  background-color: #4aae9b;\n  color: #ffffff;\n}\n", ""]);

// exports
